import React from "react";
import DatePicker from "react-datepicker";
import { Input } from "reactstrap";
import { Vmodal } from "../components";
import moment from "moment";
import { translate } from "react-i18next";
import CalendarYearDropdown from "./CalendarYearDropdown";
import "./styles/DateTimePicker.css";
class DateTimePicker extends React.Component {
  constructor(props) {
    super(props);
    let startDate = moment();
    const h24 = startDate.hour();
    const hour12 = h24 % 12 === 0 ? 12 : h24 % 12; // Convert 24h format to 12h format. And assign 12 for midnight instead of 0

    this.state = {
      modalStatus: false,
      selectedDate: startDate,
      hour: hour12,                      // ✅ 12 instead of 0 at midnight
      pmAm: h24 >= 12 ? "PM" : "AM",
      minute: startDate.minute(),
      zIndex: 8
    };
    this.hours = [];
    for (let i = 1; i <= 12; i++) {
      this.hours.push(i);
    }
    this.mins = [];
    for (let it = 0; it < 60; it++) {
      this.mins.push(it);
    }
    this.changeDateTime = this.changeDateTime.bind(this);
    this.setHours = this.setHours.bind(this);
    this.setMinutes = this.setMinutes.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      const propDate = this.props.value ? moment(this.props.value) : moment();
      const h24 = propDate.hour();
      const hour12 = h24 % 12 === 0 ? 12 : h24 % 12;
      this.setState({
        selectedDate: propDate,
        hour: hour12,
        minute: propDate.minute(),
        pmAm: h24 >= 12 ? "PM" : "AM",
      });
    }
  }

  async setHours(e) {
    const { name, value } = e.target;  // name is "hour" or "pmAm"
    let hour12 = this.state.hour;
    let pmAm = this.state.pmAm;

    if (name === "pmAm") pmAm = value;
    if (name === "hour") hour12 = parseInt(value, 10);

    // translate 12h + AM/PM → 24h
    let hour24 = hour12;
    if (pmAm === "AM" && hour12 === 12) hour24 = 0;
    if (pmAm === "PM" && hour12 !== 12) hour24 = hour12 + 12;

    // keep local 12h state in sync for the dropdowns
    await this.setState({ [name]: value });

    // apply to selectedDate immediately
    this.applyDateTimePatch({ hour: hour24 });
  }

  async setMinutes(e) {
    const minute = parseInt(e.target.value, 10);
    await this.setState({ minute });
    this.applyDateTimePatch({ minute });
  }

  changeDateTime = () => {
    this.setState({ zIndex: 8, modalStatus: false });
    this.props.onChange && this.props.onChange(this.state.selectedDate);
  };

  handleOpenCalender() {
    this.setState({ zIndex: 15 })
    this.props.disabled
      ? this.setState({ modalStatus: false })
      : this.setState({
        modalStatus: true,
      });
  }

  // Safely apply partial date/time changes and update header immediately.
  applyDateTimePatch = (patch) => {
    const { disableFutureDates } = this.props;
    const now = moment();
    let m = moment(this.state.selectedDate);

    // If month/year changes, clamp the day
    if (patch.month !== undefined || patch.year !== undefined) {
      const y = patch.year !== undefined ? patch.year : m.year();
      const mo = patch.month !== undefined ? patch.month : m.month(); // 0..11
      const currentDay = m.date();
      const dim = moment({ year: y, month: mo, day: 1 }).daysInMonth();
      const clampedDay = Math.min(currentDay, dim);
      m = m.set({ year: y, month: mo, date: clampedDay });
    }

    // If only date changes, set it directly
    if (patch.date !== undefined) m = m.date(patch.date);
    if (patch.hour !== undefined) m = m.hour(patch.hour);
    if (patch.minute !== undefined) m = m.minute(patch.minute);

    // Enforce "no future DATES" (allow future times today)
    if (disableFutureDates && m.isAfter(now, "day")) m = now;

    // 🔑 Keep the time dropdowns in sync with the final moment
    const h24 = m.hour();
    const hour12 = h24 % 12 === 0 ? 12 : h24 % 12;
    const minute = m.minute();
    const pmAm = h24 >= 12 ? "PM" : "AM";

    this.setState({
      selectedDate: m,
      hour: hour12,
      minute,
      pmAm,
    });
  };


  render() {
    const {
      input,
      placeholder,
      disabled,
      value,
      dateFormat,
      timeDisable,
      dark,
      disableFutureDates,
      showLabel,
      dailyAndAnalyze,
      pageName,
      t,
    } = this.props;
    // let format = "DD MMM YYYY, hh:mm A";
    // if (dateFormat) {
    //   format = dateFormat;
    // }
    // let showVal = "";
    // if (value) {
    //   showVal = moment(value).format(format);
    // }

    // Build value for the Occurrence Time or Date field
    let showVal = "";
    if (value) {
      const d = moment(value);
      const lang = (typeof window !== "undefined" && window.localStorage && localStorage.getItem("i18nextLng")) || "en";
      const isEn = String(lang).toLowerCase().startsWith("en");

      // Month label:
      // - English → 3-letter (MMM)
      // - Others  → full via i18n keys (meal_plan_summary.JANUARY, etc.)
      const monthEnFull = d.clone().locale("en").format("MMMM").toUpperCase();
      const monthLabel = isEn
        ? d.clone().locale("en").format("MMM")
        : t(`meal_plan_summary.${monthEnFull}`);

      // If you want to keep honoring dateFormat when passed, you can still do that,
      // but the localized month usually looks best with this template:
      showVal = `${d.format("DD")} ${monthLabel} ${d.format("YYYY")}${
        timeDisable ? "" : `, ${d.format("hh:mm A")}`
      }`;
    }


    let hour = this.state.hour; //hour24;
    let pmAm = this.state.pmAm; //"AM";
    let minutes = this.state.minute;
    let dateInput;
    dateInput = (

      <div className="dtp-smart-width">
        <DatePicker
          selected={this.state.selectedDate}
          onChange={(date) => {
            const m = moment(date);
            this.applyDateTimePatch({
              date: m.date(),
              month: m.month(),
              year: m.year(),
            });
          }}
          onMonthChange={(date) => {
            const m = moment(date);
            this.applyDateTimePatch({
              month: m.month(),   // 0..11
              year:  m.year(),    // <-- include year so Jan→Dec flips 2025→2024
            });
          }}
          onYearChange={(date) => {
            const y = moment(date).year();
            this.applyDateTimePatch({ year: y });
          }}
          maxDate={disableFutureDates ? moment().endOf("day") : undefined}
          showYearDropdown
          yearDropdownItemNumber={15}
          scrollableYearDropdown
          inline
          fixedHeight

          renderCustomHeader={({
            date,
            changeYear,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled,
          }) => {
            const year = moment(date).format("YYYY");
            const englishMonth = moment(date).locale("en").format("MMMM");
            const monthTranslated = t(`meal_plan_summary.${englishMonth.toUpperCase()}`);

            // Build years list based on rules:
            // - past 100 years
            // - future +15 if allowed, else stop at current year
            const nowY = moment().year();
            const minY = nowY - 100;
            const maxY = disableFutureDates ? nowY : nowY + 15;

            const years = [];
            for (let y = maxY; y >= minY; y--) years.push(y);

            const today = moment();
            const isShowingCurrentMonth =
              moment(date).isSame(today, "month") && moment(date).isSame(today, "year");
            const hideNextArrow = disableFutureDates && isShowingCurrentMonth;

            return (
              <div>
                {/* Previous button */}
                <button
                  type="button"
                  className="react-datepicker__navigation react-datepicker__navigation--previous"
                  onClick={decreaseMonth}
                  disabled={prevMonthButtonDisabled}
                  aria-label="Previous Month"
                >
                  <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">
                    {"<"}
                  </span>
                </button>

                {/* Next button */}
                {!hideNextArrow && (
                  <button
                    type="button"
                    className="react-datepicker__navigation react-datepicker__navigation--next"
                    onClick={increaseMonth}
                    disabled={nextMonthButtonDisabled}
                    aria-label="Next Month"
                  >
                    <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">
                      {">"}
                    </span>
                  </button>
                )}
                
                {/* This matches the default title spot (e.g., "July 2025") */}
                <div className="react-datepicker__current-month">
                  {monthTranslated} {year}
                </div>

                <CalendarYearDropdown
                  year={Number(year)}
                  years={years}
                  onChange={(y) => changeYear(y)}
                  nudgePx={15}
                />

              </div>
            );
          }}

          // Format the weekdays (e.g. Mo, Tu, We, etc in English and 一, 二, 三, in Chinese)
          formatWeekDay={nameOfDay => {
            // Convert to English base first (e.g. Monday)
            const fullDay = moment().day(nameOfDay).locale('en').format('dddd');
            const translated = t(`meal_plan_summary.${fullDay.toUpperCase()}`);

            // If language is Chinese → keep only the last character
            const lang = (typeof window !== "undefined" && window.localStorage && localStorage.getItem("i18nextLng")) || "en";

            if (lang.startsWith("zh")) {
              return translated.slice(-1);
            }
            return translated.slice(0, 2);
          }}

        />
      </div>
    );

    return (
      <div className="vDateTimeArea" style={{ zIndex: this.state.zIndex }}>
        <Vmodal
          displayStatus={this.state.modalStatus}
          data={
            <div className="TimeSelectionVdateTime">
              <h3 style={{ color: "#007bff" }}>
                {/* {moment(this.state.selectedDate).format(format)} */}

                {(() => {
                  const d = moment(this.state.selectedDate);
                  const lang = (typeof window !== "undefined" && window.localStorage && localStorage.getItem("i18nextLng")) || "en";
                  const isEn = String(lang).toLowerCase().startsWith("en");



                  // Build month label:
                  // - English → use Moment's short month (MMM)
                  // - Others  → use your i18n full month (via translation keys)
                  const monthEnFull = d.clone().locale("en").format("MMMM").toUpperCase();
                  const monthLabel = isEn
                    ? d.clone().locale("en").format("MMM")
                    : t(`meal_plan_summary.${monthEnFull}`);

                  const datePart = `${d.format("D")} ${monthLabel} ${d.format("YYYY")}`;
                  return timeDisable ? datePart : `${datePart}, ${d.format("hh:mm A")}`;
                })()}

              </h3>
              <div className="d-flex justify-content-center">
                {this.state.modalStatus ? dateInput : ""}
              </div>
              {!timeDisable && (
                <div className="d-flex justify-content-center margin-top-10">
                  <select value={hour} name="hour" onChange={this.setHours}>
                    {this.hours.map((item, index) => {
                      return (
                        <option key={index} value={item}>
                          {String(item).padStart(2, "0")}
                        </option>
                      );
                    })}
                  </select>
                  <select
                    value={minutes}
                    onChange={this.setMinutes}
                    name="minute"
                  >
                    {this.mins.map((i, index) => {
                      return (
                        <option key={index} value={i}>
                          {String(i).padStart(2, "0")}
                        </option>
                      );
                    })}
                  </select>
                  <select
                    value={pmAm}
                    name="pmAm"
                    onChange={(e) => {
                      this.setHours(e);
                    }}
                  >
                    <option>AM</option>
                    <option>PM</option>
                  </select>
                </div>
              )}
              <div className="d-flex justify-content-end margin-top-10">
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ padding: "7px 25px" }}
                  onClick={this.changeDateTime}
                >
                  {this.props.t("general.OK_PROMPT_TEXT")}
                </button>
              </div>
            </div>
          }
          closeFunc={() => {
            this.setState({
              modalStatus: false,
              minute: this.state.selectedDate.minute(),
              selectedDate: moment(value),
              zIndex: 8
            });
          }}
        />
        <Input
          placeholder={placeholder}
          disabled={disabled}
          readOnly="readonly"
          onClick={() => {
            this.setState({ modalStatus: true, zIndex: 15 });
          }}
          autoComplete="new-password"
          value={showVal}
          className={`${dark ? "chooseUser" : ""}`}
        />
        {showLabel && showVal && (
          <span
            style={{
              fontFamily: "Arial, Helvetica, sans-serif",
              position: "absolute",
              top: 5,
              right: 30,
              color: disabled ? "#999" : "#333",
              pointerEvents: "none", // ✅ Make it transparent to clicks
            }}
          >
            {placeholder}
          </span>
        )}

        <i
          className={`${disabled ? "far fa-calendar-alt disable" : "far fa-calendar-alt"
            }  ${dark ? "iChooseUser" : ""}`}
          onClick={() => {
            this.handleOpenCalender()
          }}
          style={
            dailyAndAnalyze
              ? {
                color: disabled ? "#aaa" : "#fff",
              }
              : {
                color: disabled ? "#999" : "#077bff",
              }
          }
        />
      </div>
    );
  }
}

export default translate("translations")(DateTimePicker);
// export default DateTimePicker;



// WEBPACK FOOTER //
// ./src/components/DateTimePicker.js